module.exports = __webpack_public_path__ + "static/media/chart-icon.4cff65ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart-icon.svg
// module id = 1484
// module chunks = 0